/* eslint-disable no-unused-vars */
import React from "react";
/* eslint-enable no-unused-vars */
import { createSvgIcon } from "utils";

export default createSvgIcon(
  <path d="M288,32H0v448h384V128L288,32z M352,448H32V64h224l96,96V448z" />,
  "BlankIcon",
  { viewBox: "-108 -48 608 608", fill: "#546e7a" }
);
